import { Card, CardContent, Typography, Button, Stack } from "@mui/material";
import { Upload, Download } from "@mui/icons-material";

export const WorkflowChooserCard = ({
  on_start_import,
  on_open_template_modal,
  is_sys_admin,
  selected_customer,
}) => {
  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Was möchten Sie tun?
        </Typography>
        
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Wählen Sie eine Aktion aus, um zu beginnen.
        </Typography>

        <Stack direction="row" spacing={2}>
          <Button
            variant="contained"
            startIcon={<Upload />}
            onClick={on_start_import}
            disabled={is_sys_admin && !selected_customer}
            size="large"
          >
            Import starten
          </Button>
          
          <Button
            variant="outlined"
            startIcon={<Download />}
            onClick={on_open_template_modal}
            disabled={is_sys_admin && !selected_customer}
            size="large"
          >
            Vorlage herunterladen
          </Button>
        </Stack>

        {is_sys_admin && !selected_customer && (
          <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: "block" }}>
            Bitte wählen Sie zuerst einen Kunden aus.
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};
